import styled from 'styled-components';
import { Typography, Column } from '~components';

export const Title = styled(Typography).attrs({ as: 'h2' })`
  letter-spacing: -0.03em;
  margin-top: ${({ theme }) => theme.spacing.km10};
`;

export const Description = styled(Typography).attrs({ as: 'p' })`
  margin-top: ${({ theme }) => theme.spacing.km4};
  color: ${({ theme }) => theme.color.text.neutral.weak};
  font-size: ${({ theme }) => theme.font.size.m5};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  line-height: ${({ theme }) => theme.font.lineHeight.small};
  margin-bottom: ${({ theme }) => theme.spacing.km10};
`;

export const InputContainer = styled(Column)`
  :not(:first-of-type) {
    margin-top: ${({ theme }) => theme.spacing.km10};
  }

  :nth-of-type(3) {
    margin-bottom: ${({ theme }) => theme.spacing.km10};
  }
`;
